import { render } from "./FragrancesAttributes.vue?vue&type=template&id=36666dbe&scoped=true"
import script from "./FragrancesAttributes.vue?vue&type=script&lang=js"
export * from "./FragrancesAttributes.vue?vue&type=script&lang=js"

import "./FragrancesAttributes.vue?vue&type=style&index=0&id=36666dbe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36666dbe"]])

export default __exports__